export const environment = {
  production: false,
  entorno: "Desarrollo",
  buildNumber: '#{Build.BuildNumber}#',
  appInsights: {
    instrumentationKey: '363fa37d-1684-4082-98cb-b43dd9c3f700'
  }
};
